import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CartService } from 'src/app/services/marketplace/cart.service';

/** paid: done. processing: the payment app is still confirming it.
 *  failed: declined or cancelled on the payment app's site. */
type CheckoutOutcome = 'paid' | 'processing' | 'failed';

@Component({
  selector: 'app-checkout-success',
  templateUrl: './checkout-success.component.html',
  styleUrls: ['./checkout-success.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CheckoutSuccessComponent {
  orderNumber: string | null = null;
  outcome: CheckoutOutcome = 'paid';

  constructor(route: ActivatedRoute, router: Router, cartService: CartService) {
    const params = route.snapshot.queryParamMap;
    this.orderNumber = params.get('order');

    // Only there when the buyer comes back from a payment app's site (Cash App
    // Pay, Amazon Pay, Klarna...). Card payments arrive without it.
    const redirectStatus = params.get('redirect_status');
    if (redirectStatus) {
      this.outcome = redirectStatus === 'succeeded' ? 'paid'
        : redirectStatus === 'processing' ? 'processing'
        : 'failed';
      // Drop Stripe's payment details from the address bar.
      router.navigate([], { queryParams: { order: this.orderNumber }, replaceUrl: true });
    }

    if (this.outcome !== 'failed') {
      cartService.appliedCoupon = null; // used up by this order
    }
  }
}
